import { IRankingByCourseAggregation } from '@sdk/contracts';
import { Avatar } from 'antd';
import { useMemo } from 'react';

import {
  Wrapper,
  StartContentWrapper,
  PointsWrapper,
  EndContentWrapper,
  NameWrapper,
  BadgeWrapper
} from './RankingListItem.styles';

import GAMIFICATION_RAY_ADD from '@/assets/gamification_ray_add.svg';
import { useIsMobile, usePublicProfileViewer } from '@/hooks';

type Props = {
  position: number;
  rankingItem: IRankingByCourseAggregation;
  isMe?: boolean;
};

export const RankingListItem: React.FC<Props> = ({ position, rankingItem, isMe }) => {
  const isMobile = useIsMobile('md');
  const { setUserId } = usePublicProfileViewer();

  const { _id, name, lastName, avatar, knowledgePoints } = rankingItem;

  const onClick = () => setUserId(_id);

  const getLeagueBadge = (pos: number) => {
    if (pos === 1) return '🥇';
    if (pos === 2) return '🥈';
    if (pos === 3) return '🥉';
    return pos;
  };

  const isRanking = useMemo(() => {
    return position <= 3;
  }, [position]);

  return (
    <Wrapper $isMe={isMe} onClick={onClick}>
      <StartContentWrapper>
        <BadgeWrapper $isRanking={isRanking} role="img" aria-label="League badge">
          {getLeagueBadge(position)}
        </BadgeWrapper>
        <Avatar src={avatar?.url}>{`${name[0]}${lastName[0]}`.toUpperCase()}</Avatar>
      </StartContentWrapper>
      <NameWrapper>
        {`${name}`}
        {!isMobile && ` ${lastName}`}
      </NameWrapper>
      <EndContentWrapper>
        <PointsWrapper>
          <span>{knowledgePoints}</span>
          <img src={GAMIFICATION_RAY_ADD} alt="Gamification ray" />
        </PointsWrapper>
      </EndContentWrapper>
    </Wrapper>
  );
};
